import { useState, useCallback } from "react";

export type TUseCopyToClipboardProps = {
  value?: string;
  hoverMessage?: string;
  copiedMessage?: string;
  fallbackMessage?: string;
  resetDelay?: number;
};

export const useCopyToClipboard = ({
  value,
  hoverMessage = "コピー",
  copiedMessage = "コピーしました。",
  fallbackMessage = "コピーに失敗しました。",
  resetDelay = 2000,
}: TUseCopyToClipboardProps) => {
  const [message, setMessage] = useState<string>(hoverMessage);

  const handleCopy = useCallback(async () => {
      if (!value) return;
      try {
          await navigator.clipboard.writeText(value);
          setMessage(copiedMessage);
      } catch {
          setMessage(fallbackMessage);
      } finally {
          setTimeout(() => {
              setMessage(hoverMessage);
          }, resetDelay);
      }
  }, [value, hoverMessage, copiedMessage, resetDelay]);

  return {
    message,
    copy: handleCopy,
  };
};
